/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Gallery_EmptyInputs */



/**
* | output |
* | --- |
* | "No promos yet" |
*
* @param {Promo_Gallery_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_gallery_empty = /** @type {((inputs?: Promo_Gallery_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Gallery_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune promo pour le moment")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não há promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ancora nessuna promo")
	return /** @type {LocalizedString} */ ("No promos yet")
});